import i18n from "../../locales/index"
import axios from "@/libs/axios.js"



const state = {
    Bridge: null,
    requestId: "",
    shifangIsFastSearch: false,
    shifangIsShowCategory: false,
    isAiMode: false,
    showCream: false,
    globalUseAi: false,
    initializeCamera: false,
    minNumber: 0
}

const mutations = {
    SET_BRIDGE: (state, data) => {
        state.Bridge = data
    },
    SET_MATCHID: (state, data) => {
        state.requestId = data
    },
    SET_FASTSEARCH: (state, data) => {
        state.shifangIsFastSearch = data
    },
    SET_CATEGORY: (state, data) => {
        state.shifangIsShowCategory = data
    },
    SET_IS_AIMODE: (state, data) => {
        state.isAiMode = data
    },
    SET_CREAM: (state, data) => {
        state.showCream = !state.showCream
    },
    SET_CREAM_FALSE: (state, data) => {
        state.showCream = false
    },
    SET_USE_AI: (state, data) => {
        state.globalUseAi = data
    },
    SET_MIN_NUMBER: (state, data) => {
        state.minNumber = data
    },
    SET_INIT_CAMERA: (state, data) => {
        state.initializeCamera = data
    }
}

const getters = {
    Bridge: (state) => state.Bridge,
    requestId: (state) => state.requestId,
    shifangIsFastSearch: (state) => state.shifangIsFastSearch,
    shifangIsShowCategory: (state) => state.shifangIsShowCategory,
    isAiMode: (state) => state.isAiMode,
    showCream: (state) => state.showCream,
    globalUseAi: (state) => state.globalUseAi
}

const actions = {
    async BridgeInit({
        state
    }, query) {
        await state.Bridge.invoke('activateDevice', {
            storeNo: localStorage.getItem("shop_id"),
            licenseNo: 'GMEH-6A6D-4C9Q-ZK93',
        });

        await state.Bridge.invoke('setParam', {
            compareThreshold: 0.05, // 识别阈值，范围0.01-0.5，建议0.05
            baseThreshold: 0.2, // 基础库阈值，设置为1.0关闭基础库
            clearDataParam: { // 数据清理参数
                maxFeatureCount: 100, // 最大特征数量
                maxDays: 30 // 最大保留天数
            }
        });

        await state.Bridge.invoke('setCropPoints', {
            points: [{
                    x: 100,
                    y: 100
                }, // 左上角
                {
                    x: 540,
                    y: 100
                }, // 右上角
                {
                    x: 540,
                    y: 380
                }, // 右下角
                {
                    x: 100,
                    y: 380
                } // 左下角
            ]
        });

        await state.Bridge.invoke('init');
    },

    BridgeMatchProductNameWithBasicModel({
        state
    }, query) {
        state.Bridge.invoke('matchProductNameWithBasicModel', query, function (response) {
            if (response.status === '1') {
                console.log('匹配成功');
            } else {
                console.error('匹配成功:', response);
            }
        });
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}